module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAVCAMAAAAZ+LyiAAAAYFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////98JRy6AAAAH3RSTlMA+Q/LxHphWBTluayRbQrg29bQh39mTSIbBnIn8ZtFPy3t5AAAAKNJREFUKM99z9sWgiAQheGN58qzoqbVvP9bhoAlwfRfzVr7uxmgFPEGtuKZZMoQ0WVjTa9mCUG7msMmivWKhoziDbV4CX00c8AkehITMFm1/Jramhz4qHbhjC4PqfpqTAY4qis8Q8qw6m6NxKnMqL5wTQU4ioyKtLl5xiRJF+/KmhVe1aEOkwKsShhjW+nUCKb0awawjb7hVYm/DY7hSh+d99cbfycbj27dloMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/arr-down.png
// module id = 506
// module chunks = 0